<template>
  <div class="sky-card-cascade-panel">
    <div class="sky-card-cascade-panel-tit">
      <span>已有广告系列</span>
      <el-dropdown trigger="click" @command="handleCommand">
        <span class="el-dropdown-link">
          {{dropMsg}}<i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item v-for="(item, id) in adSeriesStatus" :key="id" :command="item.value">{{ item.label }}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <el-cascader-panel
      v-loading="loading"
      v-model="list"
      @change="handleChange"
      :props="props"
      :options="optionList">
      <template slot-scope="{ node, data }">
        <!-- 根据父级id查询子集children接口数据 -->
        <div class="aaa" @click="getChildrenList(node, data)" :title="data[props.label]">{{ data[props.label] }}</div>
        <!-- 只有一级数据时显示 -->
        <!-- <span class="bbb" v-if="!isChildren"> {{ data[props.label] }} </span> -->
      </template>
    </el-cascader-panel>
  </div>
</template>
<script>
import googleads from '@/backend/services/googleAds/googleAds.js';
export default {
  name: 'sky-card-cascade-panel',
  componentName: 'sky-card-cascade-panel',
  props: {
    value: {
			type: Object,
			default: function () {
				return {};
			},
		},
    isChildren: {
      // 是否存在子集（一级子集）
      type: Boolean,
      default: false
    },
    // options: {
		// 	type: Array,
		// 	default: function () {
		// 		return [];
		// 	},
		// },
    props: {
      type: Object,
      default: function () {
        return {
          label: 'name',
          value: 'id',
          lazy: false,
        };
      },
    },
  },
  watch: {
    value: {
      handler (val) {
        if(val.seriesResourceName && val.groupResourceName) {
          this.list = [val.seriesResourceName,val.groupResourceName];
        }else if(val.seriesResourceName) {
          this.list = [val.seriesResourceName];
        }
      },
      immediate: true,
    },
  },
  data () {
    return {
      list: [],
      adSeriesStatus: [
        {
          label: '已启用',
          value: 'ENABLED'
        },
        {
          label: '已暂停',
          value: 'PAUSED'
        },
      ],
      optionList: [
        {
            label: '选择已有广告系列',
            value: 1,
            children: [
              {
                value: 'yiyou',
                label: '设计原则',
              }
            ]
        },
        {
            label: '新建广告系列',
            value: 0,
            children: [
              {
                value: 'xinjian',
                label: '设计原则2',
              }
            ]
        },
      ],
      dropMsg: '已启用',
      commandVal: 'ENABLED',
      nodeList: [],
      loading: false,
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    handleCommand(command) {
      this.list = [];
      this.commandVal = command;
      this.handleChange([]); // 查询时清空选中值
      if(command == 'ENABLED') {
        this.dropMsg = '已启用'
      }else {
        this.dropMsg = '已暂停'
      }
      this.getList();
    },
    async getList() {
      this.loading = true;
      // 获取一级列表
      let params = {
        status: this.commandVal,
      };
      let res = await googleads.getCampaignBaseList(params);
      if(this.isChildren) {
        this.optionList = this.addChildren(res.data);
      }else {
        this.optionList = res.data;
      }
      this.loading = false;
    },
    // 添加children
    addChildren(res) {
      res.forEach(item => {
        item['children'] = [];
      });
      return res;
    },
    // 获取children子集数据
    async getChildrenList(node) {
      this.nodeList = node; // 存储选中信息
      if (!this.isChildren || node.isLeaf || node.children.length) return false;
      this.loading = true;
      let params = {
        // status: this.commandVal,
        id: node.data.id
      };
      // 获取子集数据
      let res = await googleads.getAdgroupBaseList(params);
      // 获取选中id所在父级数组定位
      let id = this.optionList.findIndex(item => {
        return item[this.props.value] == node.value;
      })
      // 把子集数据注入父级children里
      this.optionList[id].children = res.data;
      this.loading = false;
    },
    handleChange (e) {
      let res = {};
      if(e.length) {
        // 广告系列
        res = {
          adSeriesId: this.nodeList.path[0].substring(this.nodeList.path[0].lastIndexOf('/')+1),
          adSeriesName:  this.nodeList.pathLabels[0],
          resourceName: this.nodeList.path[0],
        };
        if(this.isChildren) {
          // 广告组
          res['adGroupId'] = this.nodeList.path[1].substring(this.nodeList.path[1].lastIndexOf('/')+1);
          res['adGroupName'] =  this.nodeList.pathLabels[1];
          res['resourceName'] = this.nodeList.path[1];
        }
      }
      
      this.$emit('input', res);
    },
  },
};
</script>
<style lang="scss">
.sky-card-cascade-panel {
  border: 1px solid #D9D9D9;
  border-radius: 4px;
  .sky-card-cascade-panel-tit {
    display: flex;
    padding: 0 20px;
    justify-content: space-between;
    background-color: #FBFBFC;
  }
  .el-dropdown-link {
    cursor: pointer;
    color: #333333;
  }
  .el-icon-arrow-down {
    font-size: 12px;
  }
  .el-cascader-menu__wrap {
    margin-bottom: 0 !important;
  }
  .el-cascader-panel {
    .el-scrollbar.el-cascader-menu {
      flex: 1;
    }
  }
}
</style>
